export const ROUTES = {
  dashboard: '/',
  tenants: '/tenants',
  apiKeys: '/api-keys',
  login: '/auth/login',
  logout: '/auth/logout',
} as const;
